import * as React from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ContactRequest } from "../../../models/help";
import { ILocalization } from "../../../models/localization";
import { LookupType, BusyEvent } from "../../../models/enums";
import { LookupValue } from "../../../models/lookup";
import Busy from "../../widgets/busy";
import { Row, Col } from "react-flexbox-grid";
import TextField from "material-ui/TextField";
import Button from "material-ui/Button";
import Select from "material-ui/Select"
import { MenuItem } from "material-ui/Menu";
import { FormControl } from "material-ui/Form";
import { InputLabel } from "material-ui/Input";
import { sort } from "../../../utils/data";
import * as s from "./contact.css";

@observer
export default class Contact extends React.Component<{ store: SeekerStore }, {}> {
  @observable request: ContactRequest;
  @observable submitted: boolean;
  @observable emailValid: boolean;
  constructor(props: any) {
    super(props);
    this.emailValid = this.props.store.profileStore.profile ? false : true;
  }
  componentWillMount(): void {
    this.request = new ContactRequest();
    if (this.props.store.profileStore.profile) {
      this.request.email = this.props.store.profileStore.profile.demographics.emailAddress;
    }
    this.request.lang = this.props.store.localization.language;
    this.submitted = false;
  }
  @action onChange = (e: any): void => {
    const key: string = e.target.id || e.target.name;
    this.request[key] = e.target.value;

    if (key === "email") {
      this.emailValid = !this.email(this.request.email);
    }
  }

  email(value: string): boolean {
    const emailRex: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  @action submitRequest = (): void => {
    /*this.props.store.submitHelpRequest(this.request, action((resp: boolean): void => {
      if (resp) {
        this.request = new ContactRequest();
        this.submitted = true;
        setTimeout(action((): void => {
          this.submitted = false;
        }), 3000);
      }
    }));*/
  }
  render(): JSX.Element {
    const textField: any = { backgroundColor: "#ECECEC" };
    const local: ILocalization = this.props.store.localization.fields;
    const reasons: JSX.Element[] = [];
    sort(this.props.store.localization.getLookup(LookupType.ContactReason), "value").map((lv: LookupValue, i: number): void => {
      reasons.push(<MenuItem key={i} value={lv.order}>{lv.value}</MenuItem>);
    });
    let emailLabel: string = local.contactUs.email;
    if (this.request.email.length === 0) {
      emailLabel += ` (${local.required})`;
    }
    let reasonLabel: string = local.contactUs.reason;
    if (this.request.reason === 0) {
      reasonLabel += ` (${local.required})`;
    }

    console.log(this.request.email);
    return (
      <div >
        <Row className={s.row}>
          <Col xs={12}>
            <TextField autoFocus={false} label={emailLabel} error={this.request.email.length === 0} value={this.request.email} id="email" onChange={this.onChange} fullWidth />
          </Col>
        </Row>
        <Row className={s.row}>
          <Col xs={12}>
            <TextField style={textField} label={local.contactUs.message} multiline={true} rows={4} id="message" value={this.request.message} onChange={this.onChange} fullWidth />
          </Col>
        </Row>
        <Row around="md" className={s.row}>
          <Col xs={12}>
            <Busy show={this.props.store.viewState.isBusy(BusyEvent.SubmittingHelp)} />
            {!this.props.store.viewState.isBusy(BusyEvent.SubmittingHelp) && <Button onClick={this.submitRequest} disabled={this.emailValid} raised color="secondary" style={{ marginBottom: "6px" }} aria-label={local.contactUs.send}>{local.contactUs.send}</Button>}
          </Col>
        </Row>
        {this.submitted && <Row className={s.row}><Col xs={12}>{local.contactUs.submitted}</Col></Row>}
      </div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/help/contact/index.tsx